<footer class="section-space pt-5 pb-0 bg-light">
  <div class="container">
    <div class="row justify-content-between">
      <div class="col-md-4">
        <h3>Accelerate Your Vehicle Business Today!</h3>
        <button
          type="button"
          class="btn btn-outline-primary px-4 py-2 d-none d-md-block"
          data-bs-toggle="modal"
          data-bs-target="#demoModal"
        >
          Book a Demo
        </button>
      </div>
      <div class="col-md-3">
        <h6 class="fw-bold">Products</h6>
        <ul class="nav flex-column">
          <li class="nav-item">
            <a class="nav-link px-0 text-dark cursor-pointer" (click)="scrollToId('core-module')"
              >Modules</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link px-0 text-dark cursor-pointer" (click)="scrollToId('why-choose')"
              >Features</a
            >
          </li>
        </ul>
      </div>
      <div class="col-md-2">
        <h6 class="fw-bold">Resources</h6>
        <ul class="nav flex-column">
          <li class="nav-item">
            <a class="nav-link px-0 text-dark cursor-pointer" (click)="scrollToId('testimonials')"
              >Clients</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link px-0 text-dark cursor-pointer" (click)="scrollToId('faq')">Faq</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer-line w-100 my-3 border-top"></div>
    <div class="row py-4">
      <div class="col-md-8">
        <strong>Copyright &copy; 2025 <a href="https://autozaki.com">Autozaki</a>.</strong> All
        rights reserved.
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="demoModal"
    tabindex="-1"
    aria-labelledby="demoModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content shadow">
        <div class="modal-header">
          <h5 class="modal-title fw-bold" id="demoModalLabel">Book a Demo</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <form [formGroup]="bookDemoForm" #bookDemo (submit)="bookedDemo()">
          <div class="modal-body">
            <div class="mb-3">
              <label for="full_name" class="form-label">Full Name</label>
              <input
                type="text"
                class="form-control"
                id="full_name"
                name="full_name"
                formControlName="full_name"
                placeholder="Enter Full Name"
                [class.is-invalid]="
                  formData.full_name.invalid &&
                  (formData.full_name.touched || formData.full_name.dirty)
                "
              />
            </div>
            <div class="mb-3">
              <label for="email" class="form-label">Email address</label>
              <input
                type="email"
                class="form-control"
                id="email"
                name="email"
                formControlName="email"
                placeholder="Enter Email"
                [class.is-invalid]="
                  formData.email.invalid && (formData.email.touched || formData.email.dirty)
                "
              />
            </div>
            <div class="mb-3">
              <label for="company" class="form-label">Company</label>
              <input
                type="text"
                class="form-control"
                id="company"
                name="company"
                formControlName="company"
                placeholder="Enter Your Company"
                [class.is-invalid]="
                  formData.company.invalid && (formData.company.touched || formData.company.dirty)
                "
              />
            </div>
            <div class="mb-3">
              <label for="message" class="form-label">Message</label>
              <textarea
                class="form-control"
                id="message"
                name="message"
                rows="3"
                formControlName="message"
                placeholder="Enter Your Message"
                [class.is-invalid]="
                  formData.message.invalid && (formData.message.touched || formData.message.dirty)
                "
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <input
              id="bookDemoSubmit"
              type="submit"
              class="btn btn-main mr-2"
              name="submit-btn"
              value="Save"
            />
          </div>
        </form>
      </div>
    </div>
  </div>
</footer>

<!-- <div class="modal fade" id="demoModal" tabindex="-1" aria-labelledby="demoModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content shadow">
            <div class="modal-header">
                <h5 class="modal-title fw-bold" id="demoModalLabel">Book a Demo</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <form action="{{route('contact-form') }}" method="POST">
                @csrf
                <div class="modal-body">
                    <div class="mb-3">
                        <label for="name" class="form-label">Full Name</label>
                        <input type="text" class="form-control" id="name" name="name" required>
                    </div>
                    <div class="mb-3">
                        <label for="email" class="form-label">Email address</label>
                        <input type="email" class="form-control" id="email" name="email" required>
                    </div>
                    <div class="mb-3">
                        <label for="company" class="form-label">Company</label>
                        <input type="text" class="form-control" id="company" name="company">
                    </div>
                    <div class="mb-3">
                        <label for="message" class="form-label">Message</label>
                        <textarea class="form-control" id="message" name="message" rows="3"></textarea>
                    </div>
                </div>
                <div class="modal-footer">
                    <input type="submit" class="btn btn-main mr-2" name="submit-btn" value="Save" />

                </div>
            </form>
        </div>
    </div>
</div> -->
